export default "__VITE_ASSET__BgpyQRq1__"